import { Circle, List } from "../../pages/styled";
import Tooltip from "@mui/material/Tooltip";
// Mapeamento das especialidades
const mapaEspecialidades = {
  1: "Cirurgia Geral",
  2: "Clínica Médica",
  3: "Ortopedia",
  4: "Pediatria",
  5: "Gineco Obstetrícia",
  6: "Odontologia",
  7: "Oftalmologia",
  8: "Cardiologia",
  9: "Psiquiatria",
  10: "Cirurgia Plástica",
  11: "Cirurgia Pediátrica",
  12: "Emergência Clinica",
  // 13: "Observação",
  // 14: "Pronto Socorro",
  // 15: "Queimados",
  // 16: "Sala De Infusao",
  // 17: "Sala Vermelha Clinica",
};

// Cores fixas associadas a cada especialidade
const coresEspecialidades = {
  "Cirurgia Geral": "#d8600e",
  "Clínica Médica": "#8942df",
  Ortopedia: "#4fdd8d",
  Pediatria: "#8791c3",
  "Gineco Obstetrícia": "#c37881",
  Odontologia: "#f3a930",
  Oftalmologia: "#3b8bba",
  Cardiologia: "#e74c3c",
  Psiquiatria: "#6a4c93",
  "Cirurgia Plástica": "#d16d2c",
  "Cirurgia Pediátrica": "#f1c40f",
  "Emergência Clinica": "#2ecc71",
  // Observação: "#8e44ad",
  // "Pronto Socorro": "#1abc9c",
  // Queimados: "#9b59b6",
  // "Sala De Infusao": "#e67e22",
  // "Sala Vermelha Clinica": "#3498db",
};

function verificarPacientes(
  titulo,
  numeroEspecialidade,
  metricasEspecialidades
) {
  // Obtém a especialidade correspondente ao número
  const especialidade = mapaEspecialidades[numeroEspecialidade];

  if (!especialidade) {
    // Se o número não corresponder a nenhuma especialidade, retorna 0
    return 0;
  }

  // Obtém o hospital correspondente ao título
  const hospital = metricasEspecialidades[titulo];

  if (!hospital) {
    // Se o hospital não for encontrado, retorna 0
    return 0;
  }

  // Verifica se a especialidade existe no hospital
  const especialidadeData = hospital[especialidade];
  if (especialidadeData && especialidadeData.length > 0) {
    // Retorna o valor de pacientes aguardando atendimento na posição 0
    return especialidadeData[0]?.pacientes_aguardando_atendimento || 0;
  }

  // Caso a especialidade não exista, retorna 0
  return 0;
}

const EspecialidadesList = ({ titulo, metricasEspecialidades }) => {
  const maxEspecialidades = 5; // Número máximo de especialidades a exibir
  const especialidadesVisiveis = [];

  // Itera sobre todas as especialidades no mapa
  for (
    let numeroEspecialidade = 1;
    numeroEspecialidade <= Object.keys(mapaEspecialidades).length;
    numeroEspecialidade++
  ) {
    const valor = verificarPacientes(
      titulo,
      numeroEspecialidade,
      metricasEspecialidades
    );
    if (valor > 0) {
      // Adiciona a especialidade se o valor for maior que 0
      especialidadesVisiveis.push({
        especialidade: mapaEspecialidades[numeroEspecialidade],
        valor,
      });
    }
  }

  // Ordena do maior para o menor valor
  const especialidadesOrdenadas = especialidadesVisiveis
    .sort((a, b) => b.valor - a.valor)
    .slice(0, maxEspecialidades); // limita

  // Renderiza as especialidades válidas, limitadas a 5
  return (
    <List>
      {especialidadesOrdenadas.map(({ especialidade, valor }) => (
        <Tooltip key={especialidade} title={especialidade} placement="right">
          <li>
            <Circle color={coresEspecialidades[especialidade]}>{valor}</Circle>
          </li>
        </Tooltip>
      ))}
    </List>
  );
};

export default EspecialidadesList;
